var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bootom-container"},[_c('div',{staticClass:"button",on:{"click":function($event){$event.stopPropagation();return _vm.appDown($event)}}},[_vm._v("下载APP查看全部内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }